var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}





// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
const $b11ce4d5b64afe7c$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $b11ce4d5b64afe7c$export$2e2bcd8739ae039() {
    if ("serviceWorker" in navigator) {
        // The URL constructor is available in all browsers that support SW.
        const publicUrl = new URL(undefined, window.location);
        if (publicUrl.origin !== window.location.origin) // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
        return;
        window.addEventListener("load", ()=>{
            const swUrl = `/service-worker.js`;
            if (!$b11ce4d5b64afe7c$var$isLocalhost) // Is not local host. Just register service worker
            $b11ce4d5b64afe7c$var$registerValidSW(swUrl);
            else // This is running on localhost. Lets check if a service worker still exists or not.
            $b11ce4d5b64afe7c$var$checkValidServiceWorker(swUrl);
        });
    }
}
function $b11ce4d5b64afe7c$var$registerValidSW(swUrl) {
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) // At this point, the old content will have been purged and
                    // the fresh content will have been added to the cache.
                    // It's the perfect time to display a "New content is
                    // available; please refresh." message in your web app.
                    console.log("New content is available; please refresh.");
                    else // At this point, everything has been precached.
                    // It's the perfect time to display a
                    // "Content is cached for offline use." message.
                    console.log("Content is cached for offline use.");
                }
            };
        };
    }).catch((error)=>{
        console.error("Error during service worker registration:", error);
    });
}
function $b11ce4d5b64afe7c$var$checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then((response)=>{
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 || response.headers.get("content-type").indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration)=>{
            registration.unregister().then(()=>{
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $b11ce4d5b64afe7c$var$registerValidSW(swUrl);
    }).catch(()=>{
        console.log("No internet connection found. App is running in offline mode.");
    });
}
function $b11ce4d5b64afe7c$export$d07f55d4c15c0440() {
    if ("serviceWorker" in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    });
}


const $2da4ef874cc844fb$var$PICKER_OPTIONS = {
    types: [
        {
            accept: {
                "text/markdown": [
                    ".md"
                ],
                "text/plain": [
                    ".txt"
                ]
            }
        }
    ]
};
class $2da4ef874cc844fb$export$2e2bcd8739ae039 {
    constructor(){}
    get fileHandle() {
        return this._fileHandle;
    }
    set fileHandle(fileHandle) {
        this._fileHandle = fileHandle;
    }
    getFile() {
        return this._fileHandle.getFile();
    }
    async openFile() {
        const [fileHandle] = await window.showOpenFilePicker($2da4ef874cc844fb$var$PICKER_OPTIONS);
        this.fileHandle = fileHandle;
        const file = await this.getFile();
        return file;
    }
    async createFile(text) {
        const fileHandle = await window.showSaveFilePicker($2da4ef874cc844fb$var$PICKER_OPTIONS);
        this.fileHandle = fileHandle;
        const file = await this.getFile();
        await this.writeFile(text);
        return file;
    }
    async updateFile(contents) {
        if (!this.fileHandle) {
            const fileHandle = await window.showSaveFilePicker();
            this.fileHandle = fileHandle;
        }
        await this.writeFile(contents);
        const file = await this.getFile();
        return file;
    }
    async newFile() {
        const fileHandle = await window.showSaveFilePicker($2da4ef874cc844fb$var$PICKER_OPTIONS);
        this.fileHandle = fileHandle;
        const file = await this.getFile();
        return file;
    }
    async writeFile(contents) {
        if (this.fileHandle) {
            const writable = await this.fileHandle.createWritable();
            await writable.write(contents);
            await writable.close();
        }
    }
}


var $75d4fa33b7b16b97$exports = {};
!function(t) {
    "use strict";
    function e(t, e, n) {
        return n.a = t, n.f = e, n;
    }
    function F2(t) {
        return e(2, t, function(e) {
            return function(n) {
                return t(e, n);
            };
        });
    }
    function F3(t) {
        return e(3, t, function(e) {
            return function(n) {
                return function(r) {
                    return t(e, n, r);
                };
            };
        });
    }
    function F4(t) {
        return e(4, t, function(e) {
            return function(n) {
                return function(r) {
                    return function(i) {
                        return t(e, n, r, i);
                    };
                };
            };
        });
    }
    function F5(t) {
        return e(5, t, function(e) {
            return function(n) {
                return function(r) {
                    return function(i) {
                        return function(u) {
                            return t(e, n, r, i, u);
                        };
                    };
                };
            };
        });
    }
    function F6(t) {
        return e(6, t, function(e) {
            return function(n) {
                return function(r) {
                    return function(i) {
                        return function(u) {
                            return function(o) {
                                return t(e, n, r, i, u, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(t, e, n) {
        return 2 === t.a ? t.f(e, n) : t(e)(n);
    }
    function A3(t, e, n, r) {
        return 3 === t.a ? t.f(e, n, r) : t(e)(n)(r);
    }
    function A4(t, e, n, r, i) {
        return 4 === t.a ? t.f(e, n, r, i) : t(e)(n)(r)(i);
    }
    function A5(t, e, n, r, i, u) {
        return 5 === t.a ? t.f(e, n, r, i, u) : t(e)(n)(r)(i)(u);
    }
    function A6(t, e, n, r, i, u, o) {
        return 6 === t.a ? t.f(e, n, r, i, u, o) : t(e)(n)(r)(i)(u)(o);
    }
    function n(t, e, r, i) {
        if (t === e) return !0;
        if ("object" != typeof t || null === t || null === e) return "function" == typeof t && b(5), !1;
        if (r > 100) return i.push(o(t, e)), !0;
        for(var u in 0 > t.$ && (t = $e(t), e = $e(e)), t)if (!n(t[u], e[u], r + 1, i)) return !1;
        return !0;
    }
    function r(t, e, n) {
        if ("object" != typeof t) return t === e ? 0 : e > t ? -1 : 1;
        if (void 0 === t.$) return (n = r(t.a, e.a)) || (n = r(t.b, e.b)) ? n : r(t.c, e.c);
        for(; t.b && e.b && !(n = r(t.a, e.a)); t = t.b, e = e.b);
        return n || (t.b ? 1 : e.b ? -1 : 0);
    }
    var i = F2(function(t, e) {
        var n = r(t, e);
        return 0 > n ? me : n ? ve : ge;
    }), u = 0;
    function o(t, e) {
        return {
            a: t,
            b: e
        };
    }
    function a(t, e, n) {
        return {
            a: t,
            b: e,
            c: n
        };
    }
    function s(t, e) {
        var n = {};
        for(var r in t)n[r] = t[r];
        for(var r in e)n[r] = e[r];
        return n;
    }
    var c = {
        $: 0
    };
    function f(t, e) {
        return {
            $: 1,
            a: t,
            b: e
        };
    }
    var l = F2(f);
    function h(t) {
        for(var e = c, n = t.length; n--;)e = f(t[n], e);
        return e;
    }
    var p = F3(function(t, e, n) {
        for(var r = Array(t), i = 0; t > i; i++)r[i] = n(e + i);
        return r;
    }), d = F2(function(t, e) {
        for(var n = Array(t), r = 0; t > r && e.b; r++)n[r] = e.a, e = e.b;
        return n.length = r, o(n, e);
    });
    function b(t) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + t + ".md");
    }
    var g = Math.ceil, v = Math.floor, m = Math.log, k = F2(function(t, e) {
        return e.split(t);
    }), y = F2(function(t, e) {
        return e.join(t);
    });
    function $(t) {
        return {
            $: 2,
            b: t
        };
    }
    var _ = $(function(t) {
        return "number" != typeof t ? P("an INT", t) : t > -2147483647 && 2147483647 > t && (0 | t) === t ? Le(t) : !isFinite(t) || t % 1 ? P("an INT", t) : Le(t);
    }), x = $(function(t) {
        return "boolean" == typeof t ? Le(t) : P("a BOOL", t);
    }), w = ($(function(t) {
        return "number" == typeof t ? Le(t) : P("a FLOAT", t);
    }), $(function(t) {
        return Le(t);
    })), j = $(function(t) {
        return "string" == typeof t ? Le(t) : t instanceof String ? Le(t + "") : P("a STRING", t);
    }), L = F2(function(t, e) {
        return {
            $: 6,
            d: t,
            b: e
        };
    });
    function S(t, e) {
        return {
            $: 9,
            f: t,
            g: e
        };
    }
    var A = F2(function(t, e) {
        return {
            $: 10,
            b: e,
            h: t
        };
    }), E = F2(function(t, e) {
        return S(t, [
            e
        ]);
    }), C = F3(function(t, e, n) {
        return S(t, [
            e,
            n
        ]);
    }), T = F4(function(t, e, n, r) {
        return S(t, [
            e,
            n,
            r
        ]);
    }), q = F2(function(t, e) {
        return N(t, e);
    });
    function N(t, e) {
        switch(t.$){
            case 2:
                return t.b(e);
            case 5:
                return null === e ? Le(t.c) : P("null", e);
            case 3:
                return O(e) ? F(t.b, e, h) : P("a LIST", e);
            case 4:
                return O(e) ? F(t.b, e, z) : P("an ARRAY", e);
            case 6:
                var n = t.d;
                if ("object" != typeof e || null === e || !(n in e)) return P("an OBJECT with a field named `" + n + "`", e);
                var r = N(t.b, e[n]);
                return Qe(r) ? r : _e(A2(we, n, r.a));
            case 7:
                var i = t.e;
                return O(e) ? e.length > i ? (r = N(t.b, e[i]), Qe(r) ? r : _e(A2(je, i, r.a))) : P("a LONGER array. Need index " + i + " but only see " + e.length + " entries", e) : P("an ARRAY", e);
            case 8:
                if ("object" != typeof e || null === e || O(e)) return P("an OBJECT", e);
                var u = c;
                for(var a in e)if (e.hasOwnProperty(a)) {
                    if (r = N(t.b, e[a]), !Qe(r)) return _e(A2(we, a, r.a));
                    u = f(o(a, r.a), u);
                }
                return Le(Ne(u));
            case 9:
                for(var s = t.f, l = t.g, p = 0; l.length > p; p++){
                    if (r = N(l[p], e), !Qe(r)) return r;
                    s = s(r.a);
                }
                return Le(s);
            case 10:
                return r = N(t.b, e), Qe(r) ? N(t.h(r.a), e) : r;
            case 11:
                for(var d = c, b = t.g; b.b; b = b.b){
                    if (r = N(b.a, e), Qe(r)) return r;
                    d = f(r.a, d);
                }
                return _e(Se(Ne(d)));
            case 1:
                return _e(A2(xe, t.a, e));
            case 0:
                return Le(t.a);
        }
    }
    function F(t, e, n) {
        for(var r = e.length, i = Array(r), u = 0; r > u; u++){
            var o = N(t, e[u]);
            if (!Qe(o)) return _e(A2(je, u, o.a));
            i[u] = o.a;
        }
        return Le(n(i));
    }
    function O(t) {
        return Array.isArray(t) || "undefined" != typeof FileList && t instanceof FileList;
    }
    function z(t) {
        return A2(He, t.length, function(e) {
            return t[e];
        });
    }
    function P(t, e) {
        return _e(A2(xe, "Expecting " + t, e));
    }
    function M(t, e) {
        if (t === e) return !0;
        if (t.$ !== e.$) return !1;
        switch(t.$){
            case 0:
            case 1:
                return t.a === e.a;
            case 2:
                return t.b === e.b;
            case 5:
                return t.c === e.c;
            case 3:
            case 4:
            case 8:
                return M(t.b, e.b);
            case 6:
                return t.d === e.d && M(t.b, e.b);
            case 7:
                return t.e === e.e && M(t.b, e.b);
            case 9:
                return t.f === e.f && K(t.g, e.g);
            case 10:
                return t.h === e.h && M(t.b, e.b);
            case 11:
                return K(t.g, e.g);
        }
    }
    function K(t, e) {
        var n = t.length;
        if (n !== e.length) return !1;
        for(var r = 0; n > r; r++)if (!M(t[r], e[r])) return !1;
        return !0;
    }
    function R(t) {
        return t;
    }
    var I = F3(function(t, e, n) {
        return n[t] = e, n;
    });
    function B(t) {
        return {
            $: 0,
            a: t
        };
    }
    function D(t) {
        return {
            $: 2,
            b: t,
            c: null
        };
    }
    var W = F2(function(t, e) {
        return {
            $: 3,
            b: t,
            d: e
        };
    }), X = F2(function(t, e) {
        return {
            $: 4,
            b: t,
            d: e
        };
    }), G = 0;
    function U(t) {
        var e = {
            $: 0,
            e: G++,
            f: t,
            g: null,
            h: []
        };
        return Z(e), e;
    }
    function J(t) {
        return D(function(e) {
            e(B(U(t)));
        });
    }
    function Y(t, e) {
        t.h.push(e), Z(t);
    }
    var H = F2(function(t, e) {
        return D(function(n) {
            Y(t, e), n(B(u));
        });
    }), Q = !1, V = [];
    function Z(t) {
        if (V.push(t), !Q) {
            for(Q = !0; t = V.shift();)tt(t);
            Q = !1;
        }
    }
    function tt(t) {
        for(; t.f;){
            var e = t.f.$;
            if (0 === e || 1 === e) {
                for(; t.g && t.g.$ !== e;)t.g = t.g.i;
                if (!t.g) return;
                t.f = t.g.b(t.f.a), t.g = t.g.i;
            } else {
                if (2 === e) return void (t.f.c = t.f.b(function(e) {
                    t.f = e, Z(t);
                }));
                if (5 === e) {
                    if (0 === t.h.length) return;
                    t.f = t.f.b(t.h.shift());
                } else t.g = {
                    $: 3 === e ? 0 : 1,
                    b: t.f.b,
                    i: t.g
                }, t.f = t.f.d;
            }
        }
    }
    var et = {};
    function nt(t, e, n, r, i) {
        return {
            b: t,
            c: e,
            d: n,
            e: r,
            f: i
        };
    }
    function rt(t, e) {
        var n = {
            g: e,
            h: void 0
        }, r = t.c, i = t.d, u = t.e, o = t.f;
        function a(t) {
            return A2(W, a, {
                $: 5,
                b: function(e) {
                    var a = e.a;
                    return 0 === e.$ ? A3(i, n, a, t) : u && o ? A4(r, n, a.i, a.j, t) : A3(r, n, u ? a.i : a.j, t);
                }
            });
        }
        return n.h = U(A2(W, a, t.b));
    }
    var it = F2(function(t, e) {
        return D(function(n) {
            t.g(e), n(B(u));
        });
    }), ut = F2(function(t, e) {
        return A2(H, t.h, {
            $: 0,
            a: e
        });
    });
    function ot(t) {
        return function(e) {
            return {
                $: 1,
                k: t,
                l: e
            };
        };
    }
    function at(t) {
        return {
            $: 2,
            m: t
        };
    }
    var st = [], ct = !1;
    function ft(t, e, n) {
        if (st.push({
            p: t,
            q: e,
            r: n
        }), !ct) {
            ct = !0;
            for(var r; r = st.shift();)lt(r.p, r.q, r.r);
            ct = !1;
        }
    }
    function lt(t, e, n) {
        var r = {};
        for(var i in ht(!0, e, r, null), ht(!1, n, r, null), t)Y(t[i], {
            $: "fx",
            a: r[i] || {
                i: c,
                j: c
            }
        });
    }
    function ht(t, e, n, r) {
        switch(e.$){
            case 1:
                var i = e.k, u = function(t, e, n, r) {
                    function i(t) {
                        for(var e = n; e; e = e.t)t = e.s(t);
                        return t;
                    }
                    return A2(t ? et[e].e : et[e].f, i, r);
                }(t, i, r, e.l);
                return void (n[i] = function(t, e, n) {
                    return n = n || {
                        i: c,
                        j: c
                    }, t ? n.i = f(e, n.i) : n.j = f(e, n.j), n;
                }(t, u, n[i]));
            case 2:
                for(var o = e.m; o.b; o = o.b)ht(t, o.a, n, r);
                return;
            case 3:
                return void ht(t, e.o, n, {
                    s: e.n,
                    t: r
                });
        }
    }
    function pt(t) {
        et[t] && b(3);
    }
    function dt(t, e) {
        return pt(t), et[t] = {
            e: bt,
            u: e,
            a: gt
        }, ot(t);
    }
    var bt = F2(function(t, e) {
        return e;
    });
    function gt(t) {
        var e = [], n = et[t].u, r = D(function(t) {
            var e = setTimeout(function() {
                t(B(u));
            }, 0);
            return function() {
                clearTimeout(e);
            };
        });
        return et[t].b = r, et[t].c = F3(function(t, i) {
            for(; i.b; i = i.b)for(var u = e, o = n(i.a), a = 0; u.length > a; a++)u[a](o);
            return r;
        }), {
            subscribe: function(t) {
                e.push(t);
            },
            unsubscribe: function(t) {
                var n = (e = e.slice()).indexOf(t);
                0 > n || e.splice(n, 1);
            }
        };
    }
    function vt(t, e) {
        return pt(t), et[t] = {
            f: kt,
            u: e,
            a: yt
        }, ot(t);
    }
    var mt, kt = F2(function(t, e) {
        return function(n) {
            return t(e(n));
        };
    });
    function yt(t, e) {
        var n = c, r = et[t].u, i = B(null);
        return et[t].b = i, et[t].c = F3(function(t, e) {
            return n = e, i;
        }), {
            send: function(t) {
                var i = A2(q, r, t);
                Qe(i) || b(4);
                for(var u = i.a, o = n; o.b; o = o.b)e(o.a(u));
            }
        };
    }
    function $t(t, e) {
        for(var n in e)n in t ? "init" == n ? b(6) : $t(t[n], e[n]) : t[n] = e[n];
    }
    var _t = "undefined" != typeof document ? document : {};
    function xt(t, e) {
        t.appendChild(e);
    }
    function wt(t) {
        return {
            $: 0,
            a: t
        };
    }
    var jt = F2(function(t, e) {
        return F2(function(n, r) {
            for(var i = [], u = 0; r.b; r = r.b){
                var o = r.a;
                u += o.b || 0, i.push(o);
            }
            return u += i.length, {
                $: 1,
                c: e,
                d: Tt(n),
                e: i,
                f: t,
                b: u
            };
        });
    })(void 0);
    F2(function(t, e) {
        return F2(function(n, r) {
            for(var i = [], u = 0; r.b; r = r.b){
                var o = r.a;
                u += o.b.b || 0, i.push(o);
            }
            return u += i.length, {
                $: 2,
                c: e,
                d: Tt(n),
                e: i,
                f: t,
                b: u
            };
        });
    })(void 0);
    var Lt, St = F2(function(t, e) {
        return {
            $: 5,
            l: [
                t,
                e
            ],
            m: function() {
                return t(e);
            },
            k: void 0
        };
    }), At = F2(function(t, e) {
        return {
            $: "a0",
            n: t,
            o: e
        };
    }), Et = F2(function(t, e) {
        return {
            $: "a2",
            n: t,
            o: e
        };
    }), Ct = F2(function(t, e) {
        return {
            $: "a3",
            n: t,
            o: e
        };
    });
    function Tt(t) {
        for(var e = {}; t.b; t = t.b){
            var n = t.a, r = n.$, i = n.n, u = n.o;
            if ("a2" !== r) {
                var o = e[r] || (e[r] = {});
                "a3" === r && "class" === i ? qt(o, i, u) : o[i] = u;
            } else "className" === i ? qt(e, i, u) : e[i] = u;
        }
        return e;
    }
    function qt(t, e, n) {
        var r = t[e];
        t[e] = r ? r + " " + n : n;
    }
    function Nt(t, e) {
        var n = t.$;
        if (5 === n) return Nt(t.k || (t.k = t.m()), e);
        if (0 === n) return _t.createTextNode(t.a);
        if (4 === n) {
            for(var r = t.k, i = t.j; 4 === r.$;)"object" != typeof i ? i = [
                i,
                r.j
            ] : i.push(r.j), r = r.k;
            var u = {
                j: i,
                p: e
            };
            return (o = Nt(r, u)).elm_event_node_ref = u, o;
        }
        if (3 === n) return Ft(o = t.h(t.g), e, t.d), o;
        var o = t.f ? _t.createElementNS(t.f, t.c) : _t.createElement(t.c);
        mt && "a" == t.c && o.addEventListener("click", mt(o)), Ft(o, e, t.d);
        for(var a = t.e, s = 0; a.length > s; s++)xt(o, Nt(1 === n ? a[s] : a[s].b, e));
        return o;
    }
    function Ft(t, e, n) {
        for(var r in n){
            var i = n[r];
            "a1" === r ? Ot(t, i) : "a0" === r ? Mt(t, e, i) : "a3" === r ? zt(t, i) : "a4" === r ? Pt(t, i) : ("value" !== r && "checked" !== r || t[r] !== i) && (t[r] = i);
        }
    }
    function Ot(t, e) {
        var n = t.style;
        for(var r in e)n[r] = e[r];
    }
    function zt(t, e) {
        for(var n in e){
            var r = e[n];
            void 0 !== r ? t.setAttribute(n, r) : t.removeAttribute(n);
        }
    }
    function Pt(t, e) {
        for(var n in e){
            var r = e[n], i = r.f, u = r.o;
            void 0 !== u ? t.setAttributeNS(i, n, u) : t.removeAttributeNS(i, n);
        }
    }
    function Mt(t, e, n) {
        var r = t.elmFs || (t.elmFs = {});
        for(var i in n){
            var u = n[i], o = r[i];
            if (u) {
                if (o) {
                    if (o.q.$ === u.$) {
                        o.q = u;
                        continue;
                    }
                    t.removeEventListener(i, o);
                }
                o = Kt(e, u), t.addEventListener(i, o, Lt && {
                    passive: 2 > en(u)
                }), r[i] = o;
            } else t.removeEventListener(i, o), r[i] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                Lt = !0;
            }
        }));
    } catch (t) {}
    function Kt(t, e) {
        function n(e) {
            var r = n.q, i = N(r.a, e);
            if (Qe(i)) {
                for(var u, o = en(r), a = i.a, s = o ? 3 > o ? a.a : a.I : a, c = 1 == o ? a.b : 3 == o && a.aC, f = (c && e.stopPropagation(), (2 == o ? a.b : 3 == o && a.az) && e.preventDefault(), t); u = f.j;){
                    if ("function" == typeof u) s = u(s);
                    else for(var l = u.length; l--;)s = u[l](s);
                    f = f.p;
                }
                f(s, c);
            }
        }
        return n.q = e, n;
    }
    function Rt(t, e) {
        return t.$ == e.$ && M(t.a, e.a);
    }
    function It(t, e, n, r) {
        var i = {
            $: e,
            r: n,
            s: r,
            t: void 0,
            u: void 0
        };
        return t.push(i), i;
    }
    function Bt(t, e, n, r) {
        if (t !== e) {
            var i = t.$, u = e.$;
            if (i !== u) {
                if (1 !== i || 2 !== u) return void It(n, 0, r, e);
                e = function(t) {
                    for(var e = t.e, n = e.length, r = Array(n), i = 0; n > i; i++)r[i] = e[i].b;
                    return {
                        $: 1,
                        c: t.c,
                        d: t.d,
                        e: r,
                        f: t.f,
                        b: t.b
                    };
                }(e), u = 1;
            }
            switch(u){
                case 5:
                    for(var o = t.l, a = e.l, s = o.length, c = s === a.length; c && s--;)c = o[s] === a[s];
                    if (c) return void (e.k = t.k);
                    e.k = e.m();
                    var f = [];
                    return Bt(t.k, e.k, f, 0), void (f.length > 0 && It(n, 1, r, f));
                case 4:
                    for(var l = t.j, h = e.j, p = !1, d = t.k; 4 === d.$;)p = !0, "object" != typeof l ? l = [
                        l,
                        d.j
                    ] : l.push(d.j), d = d.k;
                    for(var b = e.k; 4 === b.$;)p = !0, "object" != typeof h ? h = [
                        h,
                        b.j
                    ] : h.push(b.j), b = b.k;
                    return p && l.length !== h.length ? void It(n, 0, r, e) : ((p ? function(t, e) {
                        for(var n = 0; t.length > n; n++)if (t[n] !== e[n]) return !1;
                        return !0;
                    }(l, h) : l === h) || It(n, 2, r, h), void Bt(d, b, n, r + 1));
                case 0:
                    return void (t.a !== e.a && It(n, 3, r, e.a));
                case 1:
                    return void Dt(t, e, n, r, Xt);
                case 2:
                    return void Dt(t, e, n, r, Gt);
                case 3:
                    if (t.h !== e.h) return void It(n, 0, r, e);
                    var g = Wt(t.d, e.d);
                    g && It(n, 4, r, g);
                    var v = e.i(t.g, e.g);
                    return void (v && It(n, 5, r, v));
            }
        }
    }
    function Dt(t, e, n, r, i) {
        if (t.c === e.c && t.f === e.f) {
            var u = Wt(t.d, e.d);
            u && It(n, 4, r, u), i(t, e, n, r);
        } else It(n, 0, r, e);
    }
    function Wt(t, e, n) {
        var r;
        for(var i in t)if ("a1" !== i && "a0" !== i && "a3" !== i && "a4" !== i) {
            if (i in e) {
                var u = t[i], o = e[i];
                u === o && "value" !== i && "checked" !== i || "a0" === n && Rt(u, o) || ((r = r || {})[i] = o);
            } else (r = r || {})[i] = n ? "a1" === n ? "" : "a0" === n || "a3" === n ? void 0 : {
                f: t[i].f,
                o: void 0
            } : "string" == typeof t[i] ? "" : null;
        } else {
            var a = Wt(t[i], e[i] || {}, i);
            a && ((r = r || {})[i] = a);
        }
        for(var s in e)s in t || ((r = r || {})[s] = e[s]);
        return r;
    }
    function Xt(t, e, n, r) {
        var i = t.e, u = e.e, o = i.length, a = u.length;
        o > a ? It(n, 6, r, {
            v: a,
            i: o - a
        }) : a > o && It(n, 7, r, {
            v: o,
            e: u
        });
        for(var s = a > o ? o : a, c = 0; s > c; c++){
            var f = i[c];
            Bt(f, u[c], n, ++r), r += f.b || 0;
        }
    }
    function Gt(t, e, n, r) {
        for(var i = [], u = {}, o = [], a = t.e, s = e.e, c = a.length, f = s.length, l = 0, h = 0, p = r; c > l && f > h;){
            var d = (L = a[l]).a, b = (S = s[h]).a, g = L.b, v = S.b, m = void 0, k = void 0;
            if (d !== b) {
                var y = a[l + 1], $ = s[h + 1];
                if (y) {
                    var _ = y.a, x = y.b;
                    k = b === _;
                }
                if ($) {
                    var w = $.a, j = $.b;
                    m = d === w;
                }
                if (m && k) Bt(g, j, i, ++p), Jt(u, i, d, v, h, o), p += g.b || 0, Yt(u, i, d, x, ++p), p += x.b || 0, l += 2, h += 2;
                else if (m) p++, Jt(u, i, b, v, h, o), Bt(g, j, i, p), p += g.b || 0, l += 1, h += 2;
                else if (k) Yt(u, i, d, g, ++p), p += g.b || 0, Bt(x, v, i, ++p), p += x.b || 0, l += 2, h += 1;
                else {
                    if (!y || _ !== w) break;
                    Yt(u, i, d, g, ++p), Jt(u, i, b, v, h, o), p += g.b || 0, Bt(x, j, i, ++p), p += x.b || 0, l += 2, h += 2;
                }
            } else Bt(g, v, i, ++p), p += g.b || 0, l++, h++;
        }
        for(; c > l;){
            var L;
            p++, Yt(u, i, (L = a[l]).a, g = L.b, p), p += g.b || 0, l++;
        }
        for(; f > h;){
            var S, A = A || [];
            Jt(u, i, (S = s[h]).a, S.b, void 0, A), h++;
        }
        (i.length > 0 || o.length > 0 || A) && It(n, 8, r, {
            w: i,
            x: o,
            y: A
        });
    }
    var Ut = "_elmW6BL";
    function Jt(t, e, n, r, i, u) {
        var o = t[n];
        if (!o) return u.push({
            r: i,
            A: o = {
                c: 0,
                z: r,
                r: i,
                s: void 0
            }
        }), void (t[n] = o);
        if (1 === o.c) {
            u.push({
                r: i,
                A: o
            }), o.c = 2;
            var a = [];
            return Bt(o.z, r, a, o.r), o.r = i, void (o.s.s = {
                w: a,
                A: o
            });
        }
        Jt(t, e, n + Ut, r, i, u);
    }
    function Yt(t, e, n, r, i) {
        var u = t[n];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var o = [];
                return Bt(r, u.z, o, i), void It(e, 9, i, {
                    w: o,
                    A: u
                });
            }
            Yt(t, e, n + Ut, r, i);
        } else {
            var a = It(e, 9, i, void 0);
            t[n] = {
                c: 1,
                z: r,
                r: i,
                s: a
            };
        }
    }
    function Ht(t, e, n, r) {
        Qt(t, e, n, 0, 0, e.b, r);
    }
    function Qt(t, e, n, r, i, u, o) {
        for(var a = n[r], s = a.r; s === i;){
            var c = a.$;
            if (1 === c) Ht(t, e.k, a.s, o);
            else if (8 === c) a.t = t, a.u = o, (f = a.s.w).length > 0 && Qt(t, e, f, 0, i, u, o);
            else if (9 === c) {
                a.t = t, a.u = o;
                var f, l = a.s;
                l && (l.A.s = t, (f = l.w).length > 0 && Qt(t, e, f, 0, i, u, o));
            } else a.t = t, a.u = o;
            if (!(a = n[++r]) || (s = a.r) > u) return r;
        }
        var h = e.$;
        if (4 === h) {
            for(var p = e.k; 4 === p.$;)p = p.k;
            return Qt(t, p, n, r, i + 1, u, t.elm_event_node_ref);
        }
        for(var d = e.e, b = t.childNodes, g = 0; d.length > g; g++){
            i++;
            var v = 1 === h ? d[g] : d[g].b, m = i + (v.b || 0);
            if (!(i > s || s > m || (a = n[r = Qt(b[g], v, n, r, i, m, o)]) && (s = a.r) <= u)) return r;
            i = m;
        }
        return r;
    }
    function Vt(t, e) {
        for(var n = 0; e.length > n; n++){
            var r = e[n], i = r.t, u = Zt(i, r);
            i === t && (t = u);
        }
        return t;
    }
    function Zt(t, e) {
        switch(e.$){
            case 0:
                return function(t, e, n) {
                    var r = t.parentNode, i = Nt(e, n);
                    return i.elm_event_node_ref || (i.elm_event_node_ref = t.elm_event_node_ref), r && i !== t && r.replaceChild(i, t), i;
                }(t, e.s, e.u);
            case 4:
                return Ft(t, e.u, e.s), t;
            case 3:
                return t.replaceData(0, t.length, e.s), t;
            case 1:
                return Vt(t, e.s);
            case 2:
                return t.elm_event_node_ref ? t.elm_event_node_ref.j = e.s : t.elm_event_node_ref = {
                    j: e.s,
                    p: e.u
                }, t;
            case 6:
                for(var n = e.s, r = 0; n.i > r; r++)t.removeChild(t.childNodes[n.v]);
                return t;
            case 7:
                for(var i = (n = e.s).e, u = t.childNodes[r = n.v]; i.length > r; r++)t.insertBefore(Nt(i[r], e.u), u);
                return t;
            case 9:
                if (!(n = e.s)) return t.parentNode.removeChild(t), t;
                var o = n.A;
                return void 0 !== o.r && t.parentNode.removeChild(t), o.s = Vt(t, n.w), t;
            case 8:
                return function(t, e) {
                    var n = e.s, r = function(t, e) {
                        if (t) {
                            for(var n = _t.createDocumentFragment(), r = 0; t.length > r; r++){
                                var i = t[r].A;
                                xt(n, 2 === i.c ? i.s : Nt(i.z, e.u));
                            }
                            return n;
                        }
                    }(n.y, e);
                    t = Vt(t, n.w);
                    for(var i = n.x, u = 0; i.length > u; u++){
                        var o = i[u], a = o.A, s = 2 === a.c ? a.s : Nt(a.z, e.u);
                        t.insertBefore(s, t.childNodes[o.r]);
                    }
                    return r && xt(t, r), t;
                }(t, e);
            case 5:
                return e.s(t);
            default:
                b(10);
        }
    }
    function te(t) {
        if (3 === t.nodeType) return wt(t.textContent);
        if (1 !== t.nodeType) return wt("");
        for(var e = c, n = t.attributes, r = n.length; r--;){
            var i = n[r];
            e = f(A2(Ct, i.name, i.value), e);
        }
        var u = t.tagName.toLowerCase(), o = c, a = t.childNodes;
        for(r = a.length; r--;)o = f(te(a[r]), o);
        return A3(jt, u, e, o);
    }
    var ee = F4(function(t, e, n, r) {
        return function(t, e, n, r, i, u) {
            var o = A2(q, t, e ? e.flags : void 0);
            Qe(o) || b(2);
            var a = {}, s = n(o.a), c = s.a, f = u(h, c), l = function(t, e) {
                var n;
                for(var r in et){
                    var i = et[r];
                    i.a && ((n = n || {})[r] = i.a(r, e)), t[r] = rt(i, e);
                }
                return n;
            }(a, h);
            function h(t, e) {
                var n = A2(r, t, c);
                f(c = n.a, e), ft(a, n.b, i(c));
            }
            return ft(a, s.b, i(c)), l ? {
                ports: l
            } : {};
        }(e, r, t.bK, t.cd, t.b8, function(e, n) {
            var i = t.ce, u = r.node, o = te(u);
            return function(t, e) {
                e(t);
                var n = 0;
                function r() {
                    n = 1 === n ? 0 : (ne(r), e(t), 1);
                }
                return function(i, u) {
                    t = i, u ? (e(t), 2 === n && (n = 1)) : (0 === n && ne(r), n = 2);
                };
            }(n, function(t) {
                var n = i(t), r = function(t, e) {
                    var n = [];
                    return Bt(t, e, n, 0), n;
                }(o, n);
                u = function(t, e, n, r) {
                    return 0 === n.length ? t : (Ht(t, e, n, r), Vt(t, n));
                }(u, o, r, e), o = n;
            });
        });
    }), ne = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(t) {
        return setTimeout(t, 1e3 / 60);
    });
    var re = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, ie = "undefined" != typeof document ? document : re, ue = "undefined" != typeof window ? window : re, oe = F3(function(t, e, n) {
        return J(D(function() {
            function r(t) {
                U(n(t));
            }
            return t.addEventListener(e, r, Lt && {
                passive: !0
            }), function() {
                t.removeEventListener(e, r);
            };
        }));
    }), ae = F2(function(t, e) {
        var n = N(t, e);
        return Qe(n) ? Ae(n.a) : Ee;
    });
    var se = F2(function(t, e) {
        return function(t, e) {
            return D(function(n) {
                ne(function() {
                    var r = document.getElementById(t);
                    n(r ? B(e(r)) : {
                        $: 1,
                        a: rn(t)
                    });
                });
            });
        }(e, function(e) {
            return e[t](), u;
        });
    }), ce = F3(function(t, e, n) {
        return function(t, e, n, r) {
            return {
                $: 3,
                d: Tt(t),
                g: e,
                h: n,
                i: r
            };
        }(e, {
            a: t,
            b: n
        }, fe, le);
    });
    function fe(t) {
        return A2(de, t, _t.createElement("div"));
    }
    function le(t, e) {
        return (t.b !== e.b || t.a !== e.a) && de(e);
    }
    var he, pe, de = F2(function(t, e) {
        var n, r;
        return e.innerHTML = be(t.b, {
            highlight: function(t, e) {
                return !e && Yr(n.bx) && (e = n.bx.a), "undefined" != typeof hljs && e && hljs.listLanguages().indexOf(e) >= 0 ? hljs.highlight(e, t, !0).value : t;
            },
            gfm: r = (n = t.a).bG.a,
            tables: r && r.b9,
            breaks: r && r.bs,
            sanitize: n.b6,
            smartypants: n.b7
        }), e;
    }), be = (pe = (he = {}).exports = {}, (function() {
        var t = {
            newline: /^\n+/,
            code: /^( {4}[^\n]+\n*)+/,
            fences: s,
            hr: /^( *[-*_]){3,} *(?:\n+|$)/,
            heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
            nptable: s,
            lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
            blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
            list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
            html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
            def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
            table: s,
            paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
            text: /^[^\n]+/
        };
        function e(e) {
            this.tokens = [], this.tokens.links = {}, this.options = e || f.defaults, this.rules = t.normal, this.options.gfm && (this.rules = this.options.tables ? t.tables : t.gfm);
        }
        t.bullet = /(?:[*+-]|\d+\.)/, t.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/, t.item = a(t.item, "gm")(/bull/g, t.bullet)(), t.list = a(t.list)(/bull/g, t.bullet)("hr", "\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def", "\\n+(?=" + t.def.source + ")")(), t.blockquote = a(t.blockquote)("def", t.def)(), t._tag = "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b", t.html = a(t.html)("comment", /<!--[\s\S]*?-->/)("closed", /<(tag)[\s\S]+?<\/\1>/)("closing", /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g, t._tag)(), t.paragraph = a(t.paragraph)("hr", t.hr)("heading", t.heading)("lheading", t.lheading)("blockquote", t.blockquote)("tag", "<" + t._tag)("def", t.def)(), t.normal = c({}, t), t.gfm = c({}, t.normal, {
            fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
            paragraph: /^/,
            heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
        }), t.gfm.paragraph = a(t.paragraph)("(?!", "(?!" + t.gfm.fences.source.replace("\\1", "\\2") + "|" + t.list.source.replace("\\1", "\\3") + "|")(), t.tables = c({}, t.gfm, {
            nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
            table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
        }), e.rules = t, e.lex = function(t, n) {
            return new e(n).lex(t);
        }, e.prototype.lex = function(t) {
            return t = t.replace(/\r\n|\r/g, "\n").replace(/\t/g, "    ").replace(/\u00a0/g, " ").replace(/\u2424/g, "\n"), this.token(t, !0);
        }, e.prototype.token = function(e, n, r) {
            var i, u, o, a, s, c, f, l, h;
            for(e = e.replace(/^ +$/gm, ""); e;)if ((o = this.rules.newline.exec(e)) && (e = e.substring(o[0].length), o[0].length > 1 && this.tokens.push({
                type: "space"
            })), o = this.rules.code.exec(e)) e = e.substring(o[0].length), o = o[0].replace(/^ {4}/gm, ""), this.tokens.push({
                type: "code",
                text: this.options.pedantic ? o : o.replace(/\n+$/, "")
            });
            else if (o = this.rules.fences.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: "code",
                lang: o[2],
                text: o[3] || ""
            });
            else if (o = this.rules.heading.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: "heading",
                depth: o[1].length,
                text: o[2]
            });
            else if (n && (o = this.rules.nptable.exec(e))) {
                for(e = e.substring(o[0].length), c = {
                    type: "table",
                    header: o[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: o[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: o[3].replace(/\n$/, "").split("\n")
                }, l = 0; c.align.length > l; l++)c.align[l] = /^ *-+: *$/.test(c.align[l]) ? "right" : /^ *:-+: *$/.test(c.align[l]) ? "center" : /^ *:-+ *$/.test(c.align[l]) ? "left" : null;
                for(l = 0; c.cells.length > l; l++)c.cells[l] = c.cells[l].split(/ *\| */);
                this.tokens.push(c);
            } else if (o = this.rules.lheading.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: "heading",
                depth: "=" === o[2] ? 1 : 2,
                text: o[1]
            });
            else if (o = this.rules.hr.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: "hr"
            });
            else if (o = this.rules.blockquote.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: "blockquote_start"
            }), o = o[0].replace(/^ *> ?/gm, ""), this.token(o, n, !0), this.tokens.push({
                type: "blockquote_end"
            });
            else if (o = this.rules.list.exec(e)) {
                for(e = e.substring(o[0].length), this.tokens.push({
                    type: "list_start",
                    ordered: (a = o[2]).length > 1
                }), i = !1, h = (o = o[0].match(this.rules.item)).length, l = 0; h > l; l++)f = (c = o[l]).length, ~(c = c.replace(/^ *([*+-]|\d+\.) +/, "")).indexOf("\n ") && (f -= c.length, c = c.replace(this.options.pedantic ? /^ {1,4}/gm : RegExp("^ {1," + f + "}", "gm"), "")), this.options.smartLists && l !== h - 1 && (a === (s = t.bullet.exec(o[l + 1])[0]) || a.length > 1 && s.length > 1 || (e = o.slice(l + 1).join("\n") + e, l = h - 1)), u = i || /\n\n(?!\s*$)/.test(c), l !== h - 1 && (i = "\n" === c.charAt(c.length - 1), u || (u = i)), this.tokens.push({
                    type: u ? "loose_item_start" : "list_item_start"
                }), this.token(c, !1, r), this.tokens.push({
                    type: "list_item_end"
                });
                this.tokens.push({
                    type: "list_end"
                });
            } else if (o = this.rules.html.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: this.options.sanitize ? "paragraph" : "html",
                pre: !this.options.sanitizer && ("pre" === o[1] || "script" === o[1] || "style" === o[1]),
                text: o[0]
            });
            else if (!r && n && (o = this.rules.def.exec(e))) e = e.substring(o[0].length), this.tokens.links[o[1].toLowerCase()] = {
                href: o[2],
                title: o[3]
            };
            else if (n && (o = this.rules.table.exec(e))) {
                for(e = e.substring(o[0].length), c = {
                    type: "table",
                    header: o[1].replace(/^ *| *\| *$/g, "").split(/ *\| */),
                    align: o[2].replace(/^ *|\| *$/g, "").split(/ *\| */),
                    cells: o[3].replace(/(?: *\| *)?\n$/, "").split("\n")
                }, l = 0; c.align.length > l; l++)c.align[l] = /^ *-+: *$/.test(c.align[l]) ? "right" : /^ *:-+: *$/.test(c.align[l]) ? "center" : /^ *:-+ *$/.test(c.align[l]) ? "left" : null;
                for(l = 0; c.cells.length > l; l++)c.cells[l] = c.cells[l].replace(/^ *\| *| *\| *$/g, "").split(/ *\| */);
                this.tokens.push(c);
            } else if (n && (o = this.rules.paragraph.exec(e))) e = e.substring(o[0].length), this.tokens.push({
                type: "paragraph",
                text: "\n" === o[1].charAt(o[1].length - 1) ? o[1].slice(0, -1) : o[1]
            });
            else if (o = this.rules.text.exec(e)) e = e.substring(o[0].length), this.tokens.push({
                type: "text",
                text: o[0]
            });
            else if (e) throw Error("Infinite loop on byte: " + e.charCodeAt(0));
            return this.tokens;
        };
        var n = {
            escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
            autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
            url: s,
            tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
            link: /^!?\[(inside)\]\(href\)/,
            reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
            nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
            strong: /^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
            em: /^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
            code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
            br: /^ {2,}\n(?!\s*$)/,
            del: s,
            text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
        };
        function r(t, e) {
            if (this.options = e || f.defaults, this.links = t, this.rules = n.normal, this.renderer = this.options.renderer || new i, this.renderer.options = this.options, !this.links) throw Error("Tokens array requires a `links` property.");
            this.options.gfm ? this.rules = this.options.breaks ? n.breaks : n.gfm : this.options.pedantic && (this.rules = n.pedantic);
        }
        function i(t) {
            this.options = t || {};
        }
        function u(t) {
            this.tokens = [], this.token = null, this.options = t || f.defaults, this.options.renderer = this.options.renderer || new i, this.renderer = this.options.renderer, this.renderer.options = this.options;
        }
        function o(t, e) {
            return t.replace(e ? /&/g : /&(?!#?\w+;)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
        }
        function a(t, e) {
            return t = t.source, e = e || "", function n(r, i) {
                return r ? (i = (i = i.source || i).replace(/(^|[^\[])\^/g, "$1"), t = t.replace(r, i), n) : RegExp(t, e);
            };
        }
        function s() {}
        function c(t) {
            for(var e, n, r = 1; arguments.length > r; r++)for(n in e = arguments[r])Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
            return t;
        }
        function f(t, n, r) {
            if (r || "function" == typeof n) {
                r || (r = n, n = null);
                var i, a, s = (n = c({}, f.defaults, n || {})).highlight, l = 0;
                try {
                    i = e.lex(t, n);
                } catch (t) {
                    return r(t);
                }
                a = i.length;
                var h = function(t) {
                    if (t) return n.highlight = s, r(t);
                    var e;
                    try {
                        e = u.parse(i, n);
                    } catch (e) {
                        t = e;
                    }
                    return n.highlight = s, t ? r(t) : r(null, e);
                };
                if (!s || 3 > s.length) return h();
                if (delete n.highlight, !a) return h();
                for(; i.length > l; l++)!function(t) {
                    "code" !== t.type ? --a || h() : s(t.text, t.lang, function(e, n) {
                        return e ? h(e) : null == n || n === t.text ? --a || h() : (t.text = n, t.escaped = !0, void (--a || h()));
                    });
                }(i[l]);
            } else try {
                return n && (n = c({}, f.defaults, n)), u.parse(e.lex(t, n), n);
            } catch (t) {
                if (t.message += "\nPlease report this to https://github.com/chjj/marked.", (n || f.defaults).silent) return "<p>An error occured:</p><pre>" + o(t.message + "", !0) + "</pre>";
                throw t;
            }
        }
        n._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/, n._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/, n.link = a(n.link)("inside", n._inside)("href", n._href)(), n.reflink = a(n.reflink)("inside", n._inside)(), n.normal = c({}, n), n.pedantic = c({}, n.normal, {
            strong: /^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
        }), n.gfm = c({}, n.normal, {
            escape: a(n.escape)("])", "~|])")(),
            url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
            del: /^~~(?=\S)([\s\S]*?\S)~~/,
            text: a(n.text)("]|", "~]|")("|", "|https?://|")()
        }), n.breaks = c({}, n.gfm, {
            br: a(n.br)("{2,}", "*")(),
            text: a(n.gfm.text)("{2,}", "*")()
        }), r.rules = n, r.output = function(t, e, n) {
            return new r(e, n).output(t);
        }, r.prototype.output = function(t) {
            for(var e, n, r, i, u = ""; t;)if (i = this.rules.escape.exec(t)) t = t.substring(i[0].length), u += i[1];
            else if (i = this.rules.autolink.exec(t)) t = t.substring(i[0].length), "@" === i[2] ? (n = ":" === i[1].charAt(6) ? this.mangle(i[1].substring(7)) : this.mangle(i[1]), r = this.mangle("mailto:") + n) : r = n = o(i[1]), u += this.renderer.link(r, null, n);
            else if (this.inLink || !(i = this.rules.url.exec(t))) {
                if (i = this.rules.tag.exec(t)) !this.inLink && /^<a /i.test(i[0]) ? this.inLink = !0 : this.inLink && /^<\/a>/i.test(i[0]) && (this.inLink = !1), t = t.substring(i[0].length), u += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(i[0]) : o(i[0]) : i[0];
                else if (i = this.rules.link.exec(t)) t = t.substring(i[0].length), this.inLink = !0, u += this.outputLink(i, {
                    href: i[2],
                    title: i[3]
                }), this.inLink = !1;
                else if ((i = this.rules.reflink.exec(t)) || (i = this.rules.nolink.exec(t))) {
                    if (t = t.substring(i[0].length), e = (i[2] || i[1]).replace(/\s+/g, " "), !(e = this.links[e.toLowerCase()]) || !e.href) {
                        u += i[0].charAt(0), t = i[0].substring(1) + t;
                        continue;
                    }
                    this.inLink = !0, u += this.outputLink(i, e), this.inLink = !1;
                } else if (i = this.rules.strong.exec(t)) t = t.substring(i[0].length), u += this.renderer.strong(this.output(i[2] || i[1]));
                else if (i = this.rules.em.exec(t)) t = t.substring(i[0].length), u += this.renderer.em(this.output(i[2] || i[1]));
                else if (i = this.rules.code.exec(t)) t = t.substring(i[0].length), u += this.renderer.codespan(o(i[2], !0));
                else if (i = this.rules.br.exec(t)) t = t.substring(i[0].length), u += this.renderer.br();
                else if (i = this.rules.del.exec(t)) t = t.substring(i[0].length), u += this.renderer.del(this.output(i[1]));
                else if (i = this.rules.text.exec(t)) t = t.substring(i[0].length), u += this.renderer.text(o(this.smartypants(i[0])));
                else if (t) throw Error("Infinite loop on byte: " + t.charCodeAt(0));
            } else t = t.substring(i[0].length), n = o(i[1]), u += this.renderer.link(r = n, null, n);
            return u;
        }, r.prototype.outputLink = function(t, e) {
            var n = o(e.href), r = e.title ? o(e.title) : null;
            return "!" !== t[0].charAt(0) ? this.renderer.link(n, r, this.output(t[1])) : this.renderer.image(n, r, o(t[1]));
        }, r.prototype.smartypants = function(t) {
            return this.options.smartypants ? t.replace(/---/g, "—").replace(/--/g, "–").replace(/(^|[-\u2014\/(\[{"\s])'/g, "$1‘").replace(/'/g, "’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g, "$1“").replace(/"/g, "”").replace(/\.{3}/g, "…") : t;
        }, r.prototype.mangle = function(t) {
            if (!this.options.mangle) return t;
            for(var e, n = "", r = t.length, i = 0; r > i; i++)e = t.charCodeAt(i), Math.random() > .5 && (e = "x" + e.toString(16)), n += "&#" + e + ";";
            return n;
        }, i.prototype.code = function(t, e, n) {
            if (this.options.highlight) {
                var r = this.options.highlight(t, e);
                null != r && r !== t && (n = !0, t = r);
            }
            return e ? '<pre><code class="' + this.options.langPrefix + o(e, !0) + '">' + (n ? t : o(t, !0)) + "\n</code></pre>\n" : "<pre><code>" + (n ? t : o(t, !0)) + "\n</code></pre>";
        }, i.prototype.blockquote = function(t) {
            return "<blockquote>\n" + t + "</blockquote>\n";
        }, i.prototype.html = function(t) {
            return t;
        }, i.prototype.heading = function(t, e, n) {
            return "<h" + e + ' id="' + this.options.headerPrefix + n.toLowerCase().replace(/[^\w]+/g, "-") + '">' + t + "</h" + e + ">\n";
        }, i.prototype.hr = function() {
            return this.options.xhtml ? "<hr/>\n" : "<hr>\n";
        }, i.prototype.list = function(t, e) {
            var n = e ? "ol" : "ul";
            return "<" + n + ">\n" + t + "</" + n + ">\n";
        }, i.prototype.listitem = function(t) {
            return "<li>" + t + "</li>\n";
        }, i.prototype.paragraph = function(t) {
            return "<p>" + t + "</p>\n";
        }, i.prototype.table = function(t, e) {
            return "<table>\n<thead>\n" + t + "</thead>\n<tbody>\n" + e + "</tbody>\n</table>\n";
        }, i.prototype.tablerow = function(t) {
            return "<tr>\n" + t + "</tr>\n";
        }, i.prototype.tablecell = function(t, e) {
            var n = e.header ? "th" : "td";
            return (e.align ? "<" + n + ' style="text-align:' + e.align + '">' : "<" + n + ">") + t + "</" + n + ">\n";
        }, i.prototype.strong = function(t) {
            return "<strong>" + t + "</strong>";
        }, i.prototype.em = function(t) {
            return "<em>" + t + "</em>";
        }, i.prototype.codespan = function(t) {
            return "<code>" + t + "</code>";
        }, i.prototype.br = function() {
            return this.options.xhtml ? "<br/>" : "<br>";
        }, i.prototype.del = function(t) {
            return "<del>" + t + "</del>";
        }, i.prototype.link = function(t, e, n) {
            if (this.options.sanitize) {
                try {
                    var r = decodeURIComponent((i = t, i.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(t, e) {
                        return "colon" === (e = e.toLowerCase()) ? ":" : "#" === e.charAt(0) ? "x" === e.charAt(1) ? String.fromCharCode(parseInt(e.substring(2), 16)) : String.fromCharCode(+e.substring(1)) : "";
                    }))).replace(/[^\w:]/g, "").toLowerCase();
                } catch (t) {
                    return "";
                }
                if (0 === r.indexOf("javascript:") || 0 === r.indexOf("vbscript:") || 0 === r.indexOf("data:")) return "";
            }
            var i, u = '<a href="' + t + '"';
            return e && (u += ' title="' + e + '"'), u + ">" + n + "</a>";
        }, i.prototype.image = function(t, e, n) {
            var r = '<img src="' + t + '" alt="' + n + '"';
            return e && (r += ' title="' + e + '"'), r + (this.options.xhtml ? "/>" : ">");
        }, i.prototype.text = function(t) {
            return t;
        }, u.parse = function(t, e, n) {
            return new u(e, n).parse(t);
        }, u.prototype.parse = function(t) {
            this.inline = new r(t.links, this.options, this.renderer), this.tokens = t.reverse();
            for(var e = ""; this.next();)e += this.tok();
            return e;
        }, u.prototype.next = function() {
            return this.token = this.tokens.pop();
        }, u.prototype.peek = function() {
            return this.tokens[this.tokens.length - 1] || 0;
        }, u.prototype.parseText = function() {
            for(var t = this.token.text; "text" === this.peek().type;)t += "\n" + this.next().text;
            return this.inline.output(t);
        }, u.prototype.tok = function() {
            switch(this.token.type){
                case "space":
                    return "";
                case "hr":
                    return this.renderer.hr();
                case "heading":
                    return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, this.token.text);
                case "code":
                    return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
                case "table":
                    var t, e, n, r, i = "", u = "";
                    for(n = "", t = 0; this.token.header.length > t; t++)n += this.renderer.tablecell(this.inline.output(this.token.header[t]), {
                        header: !0,
                        align: this.token.align[t]
                    });
                    for(i += this.renderer.tablerow(n), t = 0; this.token.cells.length > t; t++){
                        for(e = this.token.cells[t], n = "", r = 0; e.length > r; r++)n += this.renderer.tablecell(this.inline.output(e[r]), {
                            header: !1,
                            align: this.token.align[r]
                        });
                        u += this.renderer.tablerow(n);
                    }
                    return this.renderer.table(i, u);
                case "blockquote_start":
                    for(u = ""; "blockquote_end" !== this.next().type;)u += this.tok();
                    return this.renderer.blockquote(u);
                case "list_start":
                    u = "";
                    for(var o = this.token.ordered; "list_end" !== this.next().type;)u += this.tok();
                    return this.renderer.list(u, o);
                case "list_item_start":
                    for(u = ""; "list_item_end" !== this.next().type;)u += "text" === this.token.type ? this.parseText() : this.tok();
                    return this.renderer.listitem(u);
                case "loose_item_start":
                    for(u = ""; "list_item_end" !== this.next().type;)u += this.tok();
                    return this.renderer.listitem(u);
                case "html":
                    var a = this.token.pre || this.options.pedantic ? this.token.text : this.inline.output(this.token.text);
                    return this.renderer.html(a);
                case "paragraph":
                    return this.renderer.paragraph(this.inline.output(this.token.text));
                case "text":
                    return this.renderer.paragraph(this.parseText());
            }
        }, s.exec = s, f.options = f.setOptions = function(t) {
            return c(f.defaults, t), f;
        }, f.defaults = {
            gfm: !0,
            tables: !0,
            breaks: !1,
            pedantic: !1,
            sanitize: !1,
            sanitizer: null,
            mangle: !0,
            smartLists: !1,
            silent: !1,
            highlight: null,
            langPrefix: "lang-",
            smartypants: !1,
            headerPrefix: "",
            renderer: new i,
            xhtml: !1
        }, f.Parser = u, f.parser = u.parse, f.Renderer = i, f.Lexer = e, f.lexer = e.lex, f.InlineLexer = r, f.inlineLexer = r.output, f.parse = f, void 0 !== he && "object" == typeof pe ? he.exports = f : "function" == typeof define && define.amd ? define(function() {
            return f;
        }) : this.marked = f;
    }).call(function() {
        return this || ("undefined" != typeof window ? window : $parcel$global);
    }()), he.exports), ge = 1, ve = 2, me = 0, ke = l, ye = F3(function(t, e, n) {
        for(;;){
            if (-2 === n.$) return e;
            var r = n.d, i = t, u = A3(t, n.b, n.c, A3(ye, t, e, n.e));
            t = i, e = u, n = r;
        }
    }), $e = function(t) {
        return A3(ye, F3(function(t, e, n) {
            return A2(ke, o(t, e), n);
        }), c, t);
    }, _e = function(t) {
        return {
            $: 1,
            a: t
        };
    }, xe = F2(function(t, e) {
        return {
            $: 3,
            a: t,
            b: e
        };
    }), we = F2(function(t, e) {
        return {
            $: 0,
            a: t,
            b: e
        };
    }), je = F2(function(t, e) {
        return {
            $: 1,
            a: t,
            b: e
        };
    }), Le = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Se = function(t) {
        return {
            $: 2,
            a: t
        };
    }, Ae = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Ee = {
        $: 1
    }, Ce = F2(function(t, e) {
        return A2(y, t, function(t) {
            for(var e = []; t.b; t = t.b)e.push(t.a);
            return e;
        }(e));
    }), Te = F2(function(t, e) {
        return h(A2(k, t, e));
    }), qe = F3(function(t, e, n) {
        for(;;){
            if (!n.b) return e;
            var r = n.b, i = t, u = A2(t, n.a, e);
            t = i, e = u, n = r;
        }
    }), Ne = function(t) {
        return A3(qe, ke, c, t);
    }, Fe = 32, Oe = F4(function(t, e, n, r) {
        return {
            $: 0,
            a: t,
            b: e,
            c: n,
            d: r
        };
    }), ze = [], Pe = g, Me = F2(function(t, e) {
        return m(e) / m(t);
    }), Ke = Pe(A2(Me, 2, Fe)), Re = A4(Oe, 0, Ke, ze, ze), Ie = p, Be = v, De = function(t) {
        return t.length;
    }, We = F2(function(t, e) {
        return r(t, e) > 0 ? t : e;
    }), Xe = d, Ge = F2(function(t, e) {
        for(;;){
            var n = A2(Xe, Fe, t), r = n.b, i = A2(ke, {
                $: 0,
                a: n.a
            }, e);
            if (!r.b) return Ne(i);
            t = r, e = i;
        }
    }), Ue = F2(function(t, e) {
        for(;;){
            var n = Pe(e / Fe);
            if (1 === n) return A2(Xe, Fe, t).a;
            t = A2(Ge, t, c), e = n;
        }
    }), Je = F2(function(t, e) {
        if (e.f) {
            var n = e.f * Fe, r = Be(A2(Me, Fe, n - 1)), i = t ? Ne(e.k) : e.k, u = A2(Ue, i, e.f);
            return A4(Oe, De(e.i) + n, A2(We, 5, r * Ke), u, e.i);
        }
        return A4(Oe, De(e.i), Ke, ze, e.i);
    }), Ye = F5(function(t, e, n, r, i) {
        for(;;){
            if (0 > e) return A2(Je, !1, {
                k: r,
                f: n / Fe | 0,
                i: i
            });
            var u = {
                $: 1,
                a: A3(Ie, Fe, e, t)
            };
            e -= Fe, r = A2(ke, u, r);
        }
    }), He = F2(function(t, e) {
        if (t > 0) {
            var n = t % Fe;
            return A5(Ye, e, t - n - Fe, t, c, A3(Ie, n, t - n, e));
        }
        return Re;
    }), Qe = function(t) {
        return !t.$;
    }, Ve = E, Ze = C, tn = function(t) {
        return {
            $: 0,
            a: t
        };
    }, en = function(t) {
        switch(t.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, nn = function(t) {
        return t;
    }, rn = nn, un = B, on = un(0), an = F4(function(t, e, n, r) {
        if (r.b) {
            var i = r.a, u = r.b;
            if (u.b) {
                var o = u.a, a = u.b;
                if (a.b) {
                    var s = a.a, c = a.b;
                    if (c.b) {
                        var f = c.b;
                        return A2(t, i, A2(t, o, A2(t, s, A2(t, c.a, n > 500 ? A3(qe, t, e, Ne(f)) : A4(an, t, e, n + 1, f)))));
                    }
                    return A2(t, i, A2(t, o, A2(t, s, e)));
                }
                return A2(t, i, A2(t, o, e));
            }
            return A2(t, i, e);
        }
        return e;
    }), sn = F3(function(t, e, n) {
        return A4(an, t, e, 0, n);
    }), cn = F2(function(t, e) {
        return A3(sn, F2(function(e, n) {
            return A2(ke, t(e), n);
        }), c, e);
    }), fn = W, ln = F2(function(t, e) {
        return A2(fn, function(e) {
            return un(t(e));
        }, e);
    }), hn = F3(function(t, e, n) {
        return A2(fn, function(e) {
            return A2(fn, function(n) {
                return un(A2(t, e, n));
            }, n);
        }, e);
    }), pn = function(t) {
        return A3(sn, hn(ke), un(c), t);
    }, dn = it, bn = F2(function(t, e) {
        var n = e;
        return J(A2(fn, dn(t), n));
    });
    et.Task = nt(on, F3(function(t, e) {
        return A2(ln, function() {
            return 0;
        }, pn(A2(cn, bn(t), e)));
    }), F3(function() {
        return un(0);
    }), F2(function(t, e) {
        return A2(ln, t, e);
    }));
    var gn = ot("Task"), vn = ee, mn = F2(function(t, e) {
        return {
            p: t,
            j: e
        };
    }), kn = A, yn = j, $n = A2(kn, function(t) {
        return tn("DarkTheme" === t ? 1 : 0);
    }, yn), _n = A2(kn, function(t) {
        switch(t){
            case "Write":
            default:
                return tn(0);
            case "Focus":
                return tn(1);
            case "Read":
                return tn(2);
        }
    }, yn), xn = q, wn = L, jn = {
        bM: Ee,
        aw: "text.md",
        K: ""
    }, Ln = {
        p: 0,
        X: !1,
        P: !1,
        j: 0,
        t: jn
    }, Sn = F2(function(t, e) {
        return e.$ ? t : e.a;
    }), An = {
        $: 11
    }, En = F3(function(t, e, n) {
        return t(e(n));
    }), Cn = X, Tn = A2(F2(function(t, e) {
        return gn(A2(Cn, A2(En, A2(En, un, t), _e), A2(fn, A2(En, A2(En, un, t), Le), e)));
    }), function() {
        return An;
    }, se("focus")("app-editor")), qn = function(t) {
        return {
            $: 3,
            a: t
        };
    }, Nn = function(t) {
        return {
            $: 4,
            a: t
        };
    }, Fn = function(t) {
        return {
            $: 5,
            a: t
        };
    }, On = at, zn = w, Pn = vt("fileBuilt", zn), Mn = vt("fileLoaded", zn), Kn = x, Rn = vt("fileWritten", Kn), In = A2(Ve, function(t) {
        return {
            $: 1,
            a: t
        };
    }, A2(wn, "key", yn)), Bn = F3(function(t, e, n) {
        return {
            $: 0,
            a: t,
            b: e,
            c: n
        };
    }), Dn = F2(function(t, e) {
        return {
            a2: e,
            be: t
        };
    }), Wn = {
        $: -2
    }, Xn = Wn, Gn = un(A2(Dn, c, Xn)), Un = function(t) {
        return o(function(t, e) {
            if ("string" == typeof t) return t + e;
            if (!t.b) return e;
            var n = f(t.a, e);
            t = t.b;
            for(var r = n; t.b; t = t.b)r = r.b = f(t.a, e);
            return n;
        }(t.a ? "w_" : "d_", t.b), t);
    }, Jn = F5(function(t, e, n, r, i) {
        return {
            $: -1,
            a: t,
            b: e,
            c: n,
            d: r,
            e: i
        };
    }), Yn = F5(function(t, e, n, r, i) {
        if (-1 !== i.$ || i.a) {
            if (-1 !== r.$ || r.a || -1 !== r.d.$ || r.d.a) return A5(Jn, t, e, n, r, i);
            var u = r.d;
            return o = r.e, A5(Jn, 0, r.b, r.c, A5(Jn, 1, u.b, u.c, u.d, u.e), A5(Jn, 1, e, n, o, i));
        }
        var o, a = i.b, s = i.c, c = i.d, f = i.e;
        return -1 !== r.$ || r.a ? A5(Jn, t, a, s, A5(Jn, 0, e, n, r, c), f) : A5(Jn, 0, e, n, A5(Jn, 1, r.b, r.c, r.d, o = r.e), A5(Jn, 1, a, s, c, f));
    }), Hn = i, Qn = F3(function(t, e, n) {
        if (-2 === n.$) return A5(Jn, 0, t, e, Wn, Wn);
        var r = n.a, i = n.b, u = n.c, o = n.d, a = n.e;
        switch(A2(Hn, t, i)){
            case 0:
                return A5(Yn, r, i, u, A3(Qn, t, e, o), a);
            case 1:
                return A5(Jn, r, i, e, o, a);
            default:
                return A5(Yn, r, i, u, o, A3(Qn, t, e, a));
        }
    }), Vn = F3(function(t, e, n) {
        var r = A3(Qn, t, e, n);
        return -1 !== r.$ || r.a ? r : A5(Jn, 1, r.b, r.c, r.d, r.e);
    }), Zn = function(t) {
        return A3(qe, F2(function(t, e) {
            return A3(Vn, t.a, t.b, e);
        }), Xn, t);
    }, tr = function(t) {
        return D(function(e) {
            var n = t.f;
            2 === n.$ && n.c && n.c(), t.f = null, e(B(u));
        });
    }, er = F3(function(t, e, n) {
        for(;;){
            if (-2 === n.$) return e;
            var r = n.e, i = t, u = A3(t, n.b, n.c, A3(er, t, e, n.d));
            t = i, e = u, n = r;
        }
    }), nr = F6(function(t, e, n, i, u, a) {
        var s = A3(er, F3(function(i, u, a) {
            t: for(;;){
                var s = a.a, c = a.b;
                if (s.b) {
                    var f = s.a, l = f.a, h = f.b, p = s.b;
                    if (0 > r(l, i)) {
                        a = o(p, A3(t, l, h, c));
                        continue t;
                    }
                    return r(l, i) > 0 ? o(s, A3(n, i, u, c)) : o(p, A4(e, l, h, u, c));
                }
                return o(s, A3(n, i, u, c));
            }
        }), o($e(i), a), u), c = s.a, f = s.b;
        return A3(qe, F2(function(e, n) {
            return A3(t, e.a, e.b, n);
        }), f, c);
    }), rr = F2(function(t, e) {
        return {
            aN: e,
            aU: t
        };
    }), ir = ut, ur = F3(function(t, e, n) {
        return A2(ln, function(t) {
            return o(e, t);
        }, A3(oe, n.a ? ue : ie, n.b, function(n) {
            return A2(ir, t, A2(rr, e, n));
        }));
    }), or = F2(function(t, e) {
        return A3(er, Vn, e, t);
    }), ar = F3(function(t, e, n) {
        var r = F3(function(e, n, r) {
            var i = r.c;
            return a(r.a, r.b, A2(ke, A3(ur, t, e, n), i));
        }), i = F3(function(t, e, n) {
            var r = n.b, i = n.c;
            return a(A2(ke, e, n.a), r, i);
        }), u = F4(function(t, e, n, r) {
            var i = r.c;
            return a(r.a, A3(Vn, t, e, r.b), i);
        }), o = A2(cn, Un, e), s = A6(nr, i, u, r, n.a2, Zn(o), a(c, Xn, c)), f = s.b, l = s.c;
        return A2(fn, function(t) {
            return un(A2(Dn, o, A2(or, f, Zn(t))));
        }, A2(fn, function() {
            return pn(l);
        }, pn(A2(cn, tr, s.a))));
    }), sr = F3(function(t, e, n) {
        var r = t(e);
        return r.$ ? n : A2(ke, r.a, n);
    }), cr = F2(function(t, e) {
        return A3(sn, sr(t), c, e);
    });
    et["Browser.Events"] = nt(Gn, ar, F3(function(t, e, r) {
        var i = e.aU, u = e.aN, o = A2(cr, function(t) {
            var e = t.b.c;
            return function(t, e) {
                for(var r, i = [], u = n(t, e, 0, i); u && (r = i.pop()); u = n(r.a, r.b, 0, i));
                return u;
            }(t.a, i) ? A2(ae, e, u) : Ee;
        }, r.be);
        return A2(fn, function() {
            return un(r);
        }, pn(A2(cn, dn(t), o)));
    }), 0, F2(function(t, e) {
        return A3(Bn, e.a, e.b, A2(Ve, t, e.c));
    }));
    var fr = ot("Browser.Events"), lr = A2(F3(function(t, e, n) {
        return fr(A3(Bn, t, e, n));
    }), 0, "keydown"), hr = at, pr = R, dr = function(t) {
        switch(t){
            case 0:
                return "Write";
            case 1:
                return "Focus";
            default:
                return "Read";
        }
    }, br = dt("setStorage", nn), gr = {
        $: 6
    }, vr = dt("changeText", pr), mr = F3(function(t, e, n) {
        return {
            bM: e,
            aw: t,
            K: n
        };
    }), kr = _, yr = T, $r = function(t) {
        return {
            $: 5,
            c: t
        };
    }, _r = function(t) {
        var e = A4(yr, mr, A2(wn, "name", yn), A2(wn, "lastModified", function(t) {
            return {
                $: 11,
                g: h([
                    $r(Ee),
                    A2(Ve, Ae, t)
                ])
            };
        }(kr)), A2(wn, "text", yn));
        return A2(xn, e, t);
    }, xr = F3(function(t, e, n) {
        return A2(Ce, e, A2(Te, t, n));
    }), wr = function(t) {
        return "# " + A3(xr, ".md", "", t.aw);
    }, jr = dt("newFile", function() {
        return null;
    }), Lr = hr(c), Sr = dt("openFile", function() {
        return null;
    }), Ar = dt("saveFile", pr), Er = function(t) {
        switch(t){
            case 1:
                return 2;
            case 2:
                return 1;
            default:
                return t;
        }
    }, Cr = dt("writeFile", pr), Tr = F2(function(t, e) {
        t: for(;;)switch(t.$){
            case 0:
                var n = t.a;
                return o(s(e, {
                    t: s(a = e.t, {
                        K: n
                    })
                }), hr(h([
                    vr(n)
                ])));
            case 1:
                var r = t.a;
                if (!e.P) return o(s(e, "Control" === r ? {
                    P: !0
                } : {
                    P: !1
                }), Lr);
                switch(r){
                    case "Control":
                        var i = Er(e.j);
                        return o(s(e, {
                            P: !1,
                            j: i
                        }), Tn);
                    case "s":
                        t = gr;
                        continue t;
                    default:
                        return o(s(e, {
                            P: !1
                        }), Lr);
                }
            case 2:
                return o(s(e, {
                    j: t.a
                }), Lr);
            case 5:
                var u = _r(t.a), a = function() {
                    if (u.$) return jn;
                    var t, n = u.a;
                    return s(n, {
                        K: (t = e.t.K, "" === t ? wr(n) : e.t.K)
                    });
                }();
                return o(s(e, {
                    t: a
                }), Lr);
            case 3:
                return u = _r(t.a), o(s(e, {
                    t: a = u.$ ? jn : u.a
                }), Tn);
            case 4:
                return o(e, Lr);
            case 6:
                return o(e, hr(h(e.t.bM.$ ? [
                    Ar(e.t.K)
                ] : [
                    Cr(e.t.K)
                ])));
            case 7:
                return o(s(e, {
                    p: (l = e.p, 1 === l ? 0 : 1)
                }), Lr);
            case 8:
                var c = !e.X, f = c ? Lr : Tn;
                return o(s(e, {
                    X: c
                }), f);
            case 9:
                return o(e, hr(h([
                    Sr(0)
                ])));
            case 10:
                return o(e, hr(h([
                    jr(0)
                ])));
            default:
                return o(e, Lr);
        }
        var l;
    }), qr = F2(function(t, e) {
        var n, r, i, u, a = A2(Tr, t, e), s = a.a, c = a.b;
        return o(s, hr(h([
            br((n = {
                p: s.p,
                j: s.j
            }, r = h([
                o("colorTheme", (u = n.p, pr(1 === u ? "DarkTheme" : "WhiteTheme"))),
                o("layoutMode", (i = n.j, pr(dr(i))))
            ]), A3(qe, F2(function(t, e) {
                return A3(I, t.a, t.b, e);
            }), {}, r))),
            c
        ])));
    }), Nr = F2(function(t, e) {
        return A2(Et, t, pr(e));
    }), Fr = Nr("className"), Or = jt("div"), zr = St, Pr = function(t) {
        return {
            $: 0,
            a: t
        };
    }, Mr = Nr("id"), Kr = function(t) {
        return o(t, !0);
    }, Rr = At, Ir = F2(function(t, e) {
        return A2(Rr, t, {
            $: 1,
            a: e
        });
    }), Br = F2(function(t, e) {
        return A3(sn, wn, e, t);
    }), Dr = A2(Br, h([
        "target",
        "value"
    ]), yn), Wr = Nr("placeholder"), Xr = jt("textarea"), Gr = Nr("value"), Ur = function(t) {
        var e;
        return A2(Or, h([
            Fr(2 !== t.j ? "app-editor" : "app-editor app-editor--hidden")
        ]), h([
            A2(Xr, h([
                (e = Pr, A2(Ir, "input", A2(Ve, Kr, A2(Ve, e, Dr)))),
                Wr("# Markdown text here"),
                Gr(t.t.K),
                Mr("app-editor")
            ]), c)
        ]));
    }, Jr = {
        bx: Ee,
        bG: Ae({
            bs: !1,
            b9: !0
        }),
        b6: !0,
        b7: !1
    }, Yr = function(t) {
        return !t.$;
    }, Hr = ce, Qr = function(t) {
        return A2(Or, h([
            Fr("app-preview")
        ]), h([
            A3(Hr, Jr, c, t.K)
        ]));
    }, Vr = {
        $: 8
    }, Zr = jt("button"), ti = jt("nav"), ei = F2(function(t, e) {
        return A2(Rr, t, {
            $: 0,
            a: e
        });
    }), ni = function(t) {
        return A2(ei, "click", tn(t));
    }, ri = wt, ii = {
        $: 10
    }, ui = {
        $: 9
    }, oi = F2(function(t, e) {
        return {
            $: 2,
            a: t,
            b: e
        };
    }), ai = function(t) {
        return {
            $: 7,
            a: t
        };
    }, si = R, ci = F2(function(t, e) {
        return A2(Et, t, si(e));
    })("checked"), fi = jt("fieldset"), li = Nr("htmlFor"), hi = jt("h2"), pi = jt("input"), di = jt("label"), bi = jt("legend"), gi = Nr("name"), vi = A2(Br, h([
        "target",
        "checked"
    ]), Kn), mi = function(t) {
        return A2(ei, "change", A2(Ve, t, vi));
    }, ki = Nr("type"), yi = function(t) {
        var e = h([
            A2(Or, h([
                Fr("app-sidebar__body__section")
            ]), h([
                A2(hi, c, h([
                    ri("File")
                ])),
                A2(Or, h([
                    Fr("app-sidebar__body__section__buttons")
                ]), h([
                    A2(Zr, h([
                        ni(ii)
                    ]), h([
                        ri("New")
                    ])),
                    A2(Zr, h([
                        ni(ui)
                    ]), h([
                        ri("Open")
                    ]))
                ]))
            ])),
            A2(fi, h([
                Fr("app-sidebar__body__section")
            ]), h([
                A2(bi, c, h([
                    ri("Layout")
                ])),
                A2(pi, h([
                    ki("radio"),
                    Mr("layout-radio-split"),
                    Gr("split"),
                    ci(!t.j),
                    mi(oi(0)),
                    Fr("app-sidebar__body__radio"),
                    gi("layout")
                ]), c),
                A2(di, h([
                    li("layout-radio-split")
                ]), h([
                    ri("split")
                ])),
                A2(pi, h([
                    ki("radio"),
                    Mr("layout-radio-edit"),
                    Gr("edit"),
                    ci(1 === t.j),
                    mi(oi(1)),
                    Fr("app-sidebar__body__radio"),
                    gi("layout")
                ]), c),
                A2(di, h([
                    li("layout-radio-edit")
                ]), h([
                    ri("edit")
                ])),
                A2(pi, h([
                    ki("radio"),
                    Mr("layout-radio-view"),
                    Gr("view"),
                    ci(2 === t.j),
                    mi(oi(2)),
                    Fr("app-sidebar__body__radio"),
                    gi("layout")
                ]), c),
                A2(di, h([
                    li("layout-radio-view")
                ]), h([
                    ri("view")
                ]))
            ])),
            A2(fi, h([
                Fr("app-sidebar__body__section")
            ]), h([
                A2(bi, c, h([
                    ri("Theme")
                ])),
                A2(pi, h([
                    ki("radio"),
                    Mr("layout-radio-white"),
                    Gr("white"),
                    ci(!t.p),
                    mi(ai),
                    Fr("app-sidebar__body__radio"),
                    gi("theme")
                ]), c),
                A2(di, h([
                    li("layout-radio-white")
                ]), h([
                    ri("white")
                ])),
                A2(pi, h([
                    ki("radio"),
                    Mr("layout-radio-dark"),
                    Gr("dark"),
                    ci(1 === t.p),
                    mi(ai),
                    Fr("app-sidebar__body__radio"),
                    gi("theme")
                ]), c),
                A2(di, h([
                    li("layout-radio-dark")
                ]), h([
                    ri("dark")
                ]))
            ]))
        ]);
        return A2(Or, h([
            Fr("app-sidebar__body")
        ]), e);
    }, $i = function(t) {
        return A2(ti, h([
            Fr(t.X ? "app-sidebar app-sidebar--open" : "app-sidebar app-sidebar--closed")
        ]), h([
            A2(Or, h([
                Fr("app-sidebar__buttons")
            ]), h([
                A2(Zr, h([
                    Fr("app-sidebar__button"),
                    ni(gr)
                ]), h([
                    ri("Save text")
                ])),
                A2(Zr, h([
                    Fr("app-sidebar__button"),
                    ni(Vr)
                ]), h([
                    ri(t.X ? "Close sidebar" : "Open sidebar")
                ]))
            ])),
            yi(t)
        ]));
    };
    !function(e) {
        t.Elm ? $t(t.Elm, e) : t.Elm = e;
    }({
        Main: {
            init: vn({
                bK: function(t) {
                    return o(function(t) {
                        var e = function(t) {
                            return A2(xn, A3(Ze, mn, A2(wn, "colorTheme", $n), A2(wn, "layoutMode", _n)), t);
                        }(t), n = e.$ ? Ee : Ae(e.a), r = A2(Sn, {
                            p: Ln.p,
                            j: Ln.j
                        }, n);
                        return s(Ln, {
                            p: r.p,
                            j: r.j
                        });
                    }(t), Tn);
                },
                b8: function() {
                    return On(h([
                        Mn(qn),
                        Rn(Nn),
                        Pn(Fn),
                        lr(In)
                    ]));
                },
                cd: qr,
                ce: function(t) {
                    var e, n, r;
                    return A2(Or, h([
                        Fr("app-wrapper " + (r = t.p, r ? "app-wrapper--dark-theme" : "app-wrapper--white-theme"))
                    ]), h([
                        A2(Or, h([
                            Fr("app-layout " + (n = t.j, "app-layout--" + (e = dr(n), e.toLowerCase())))
                        ]), h([
                            Ur(t),
                            A2(zr, Qr, t.t),
                            $i(t)
                        ]))
                    ]));
                }
            })(zn)(0)
        }
    });
}($75d4fa33b7b16b97$exports);


const $0a4317a2b55cfedb$var$runElmApp = ()=>{
    const storedState = localStorage.getItem("elm-editor-save");
    const startingState = storedState ? JSON.parse(storedState) : null;
    const node = document.getElementById("root");
    const app = (0, $75d4fa33b7b16b97$exports.Elm).Main.init({
        node: node,
        flags: startingState
    });
    const fileHandleManager = new (0, $2da4ef874cc844fb$export$2e2bcd8739ae039)();
    const appState = {
        filename: "",
        hasUnsavedChange: false
    };
    const setDocumentTitle = ()=>{
        const { filename: filename, hasUnsavedChange: hasUnsavedChange } = appState;
        document.title = `${hasUnsavedChange ? "* " : ""}${filename ? `${filename} - ` : ""}Nekobito`;
    };
    const handleLoadFile = (file)=>{
        appState.filename = file.name;
        appState.hasUnsavedChange = false;
        setDocumentTitle();
    };
    //
    // ports
    //
    app.ports.setStorage.subscribe((state)=>{
        localStorage.setItem("elm-editor-save", JSON.stringify(state));
    });
    // update file
    app.ports.writeFile.subscribe(async (contents)=>{
        const file = await fileHandleManager.updateFile(contents);
        handleLoadFile(file);
        app.ports.fileWritten.send(true);
    });
    // open file
    app.ports.openFile.subscribe(async ()=>{
        const file = await fileHandleManager.openFile();
        const { name: name, lastModified: lastModified } = file;
        const text = await file.text();
        handleLoadFile(file);
        app.ports.fileLoaded.send({
            name: name,
            lastModified: lastModified,
            text: text
        });
    });
    // new file
    app.ports.newFile.subscribe(async ()=>{
        const file = await fileHandleManager.newFile();
        handleLoadFile(file);
        const { name: name, lastModified: lastModified } = file;
        app.ports.fileBuilt.send({
            name: name,
            lastModified: lastModified,
            text: ""
        });
    });
    app.ports.changeText.subscribe(()=>{
        appState.hasUnsavedChange = true;
        setDocumentTitle();
    });
    // create a new file
    app.ports.saveFile.subscribe(async (text)=>{
        const file = await fileHandleManager.createFile(text);
        handleLoadFile(file);
        const { name: name, lastModified: lastModified } = file;
        app.ports.fileBuilt.send({
            name: name,
            lastModified: lastModified,
            text: text
        });
    });
};
var $0a4317a2b55cfedb$export$2e2bcd8739ae039 = $0a4317a2b55cfedb$var$runElmApp;


(0, $0a4317a2b55cfedb$export$2e2bcd8739ae039)();
// Enable Service Worker to run as a PWA app
(0, $b11ce4d5b64afe7c$export$2e2bcd8739ae039)();


//# sourceMappingURL=index.1ff194bc.js.map
